module.exports = __webpack_public_path__ + "static/media/S1-25-Nergyzzak-cod45.2b42fa71.png";